import { HelmetProvider } from "react-helmet-async";
import { Outlet, Route, Routes } from "react-router-dom";

import GoogleTag from "@/components/common/common/GoogleTag";
import Layout from "@/components/user/layout/Layout";
import ProgramLayout from "@/components/user/layout/ProgramLayout";
import SubLayout from "@/components/user/layout/SubLayout";
import NotFound from "@/pages/common/NotFound";
import About from "@/pages/user/about/About";
import Location from "@/pages/user/about/Location";
import Map from "@/pages/user/about/Map";
import History from "@/pages/user/archive/History";
import SoundTrack from "@/pages/user/archive/SoundTrack";
import Board from "@/pages/user/community/Board";
import BoardDetail from "@/pages/user/community/BoardDetail";
import Contact from "@/pages/user/community/Contact";
import Faq from "@/pages/user/community/Faq";
import Landing from "@/pages/user/landing/Landing";
import Main from "@/pages/user/main/Main";
import Art from "@/pages/user/program/Art";
import Festa from "@/pages/user/program/Festa";
import Focus from "@/pages/user/program/Focus";
import Play from "@/pages/user/program/Play";
import Schedule from "@/pages/user/program/Schedule";
import Stage from "@/pages/user/program/Stage";

function UserApp() {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <HelmetProvider>
                        <GoogleTag id="G-0DJNRYZG1S" />
                        <Layout>
                            <Outlet />
                        </Layout>
                    </HelmetProvider>
                }
            >
                {/* 메인 페이지 */}
                <Route index element={<Main />} />

                {/* 서브 페이지 */}
                <Route
                    element={
                        <SubLayout>
                            <Outlet />
                        </SubLayout>
                    }
                >
                    <Route path="about" element={<About />} />
                    <Route path="location" element={<Location />} />
                    <Route path="map" element={<Map />} />
                    <Route path="schedule" element={<Schedule />} />
                    <Route
                        path="/program"
                        element={
                            <ProgramLayout>
                                <Outlet />
                            </ProgramLayout>
                        }
                    >
                        <Route path="stage" element={<Stage />} />
                        <Route path="play" element={<Play />} />
                        <Route path="art" element={<Art />} />
                        <Route path="focus" element={<Focus />} />
                        <Route path="festa" element={<Festa />} />
                    </Route>
                </Route>
                <Route
                    path="/community"
                    element={
                        <SubLayout className="bg-[#F1F4F9] before:border-[#F1F4F9] before:border-t-transparent before:border-r-transparent">
                            <Outlet />
                        </SubLayout>
                    }
                >
                    <Route path=":category" element={<Board />} />
                    <Route path=":category/:board_idx" element={<BoardDetail />} />
                    <Route path="faq" element={<Faq />} />
                    <Route path="contact" element={<Contact />} />
                </Route>
                <Route
                    path="/archive"
                    element={
                        <SubLayout className="bg-[#F1F4F9] before:border-[#F1F4F9] before:border-t-transparent before:border-r-transparent">
                            <Outlet />
                        </SubLayout>
                    }
                >
                    <Route path="history" element={<History />} />
                    <Route path="soundtrack" element={<SoundTrack />} />
                </Route>
            </Route>
            <Route
                path="/landing"
                element={
                    <HelmetProvider>
                        <GoogleTag id="G-09GB3LCE1F" />
                        <Landing />
                    </HelmetProvider>
                }
            />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default UserApp;
